/**
 * Window event the API client dispatches when the backend answers 401: the token is gone or
 * invalid. The auth store listens and switches to signed out; nothing navigates.
 */
export const UNAUTHORIZED_EVENT = 'lukaaji:unauthorized';
